import { useQuery } from "@apollo/client";
import { Badge, Colors } from "react-native-ui-lib";
import { QUERY_COUNT_STOCK_ORDERS } from "../../modules/stock-order/utils";

export const PendingStockOrdersCountChip = () => {
  const { data, loading, error } = useQuery<{
    stockOrdersCount: number;
  }>(QUERY_COUNT_STOCK_ORDERS, {
    fetchPolicy: "cache-and-network",
    pollInterval: 30000,
    variables: {
      options: {
        filter: {
          status: {
            in: ["PENDING"],
          },
        },
      },
    },
  });

  if (loading || error) {
    return null;
  }

  return (
    <Badge
      label={(data?.stockOrdersCount ?? 0).toString()}
      labelStyle={{
        color: Colors.black,
      }}
      backgroundColor="rgb(216, 217, 219)"
    />
  );
};
